$(function () {
	const $updateStatusSelect = $('.js-new-status-select');

	const label = `<svg width="12" height="10" viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg">
	<path d="M12 4.99992L9.1 9.09992C8.97778 9.2777 8.81956 9.41659 8.62533 9.51659C8.43111 9.61659 8.22267 9.66659 8 9.66659H1.33333C0.966668 9.66659 0.652668 9.53592 0.391334 9.27459C0.130001 9.01325 -0.000443313 8.69948 1.13186e-06 8.33325V1.66659C1.13186e-06 1.29992 0.130668 0.98592 0.392001 0.724586C0.653334 0.463253 0.967112 0.332809 1.33333 0.333253H8C8.22222 0.333253 8.43067 0.383253 8.62533 0.483253C8.82 0.583253 8.97822 0.722142 9.1 0.89992L12 4.99992Z" fill="currentColor"/>
	</svg>`

	function formatState(state) {
		var element = state.element;

		if (!element) {
			return state.text;
		}

		var $text = $('<span />').text(state.text);

		var $icon = $('<i></i>').append(label);

		return $('<div />', { 'data-value': $(element).attr('value') })
			.css({ 'white-space': 'nowrap' })
			.append($icon, $text);
	}

	const $statusSelect = $updateStatusSelect?.select2({
		width: 'style',
		dropdownAutoWidth: true,
		theme: "default outline status",
		minimumResultsForSearch: -1,
		templateResult: formatState,
		templateSelection: formatState,
		placeholder: 'Select status',
		dropdownParent: $('#update_status')
	});

	$statusSelect.on('change', e => {
		const $target = $(e.target);
	
		$target.attr('data-value', e.target.value);
	});
});
